module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0874.1f6b3110.jpg";